import React from 'react';
import { CellBPKeywords, Row, CellContainer } from '@bit/knotchinc.web-react-components.table-sync';
import { StyledContentTitle, StyledEntityTitle, ContentContainer, ValueContainer, Value, ValueDesc } from '../styled.js';

export const ContentSharesOverviewRow = (props) => {
  const { data = {}, allowMultiline } = props;
  const { brand = {}, publisher = {}, title, num_shares } = data;

  return (
    <Row {...props} allowMultiline={allowMultiline}>
      <CellContainer width={0.4}>
        <ContentContainer padding={allowMultiline ? '12px 0' : ''}>
          <StyledContentTitle allowMultiline>{title}</StyledContentTitle>
          <StyledEntityTitle>{brand.name} x {publisher.name}</StyledEntityTitle>
        </ContentContainer>
      </CellContainer>
      <CellBPKeywords allowMultiline={allowMultiline} width={allowMultiline ? 0.45 : 0.5} data={data} />
      <CellContainer width={allowMultiline ? 0.15 : 0.1}>
        <ValueContainer>
          <Value>{num_shares}</Value>
          <ValueDesc>Shares</ValueDesc>
        </ValueContainer>
      </CellContainer>
    </Row>
  );
};
